import { generateUUID } from "../../components/helpers/uuidgenerator";
import dayjs from "dayjs";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Trash2 } from "lucide-react";

export const ChallengeBlock = ({ ch, i, formStates, setFormStates }) => {
  const handleChange = (i, name, value) => {
    setFormStates((prev) => {
      let cArr = prev.challenge;
      cArr[i] = { ...cArr[i], [name]: value };
      return { ...prev, challenge: [...cArr] };
    });
  };

  const deleteChallenge = (i) => {
    setFormStates((prev) => {
      let chNo = prev.season.challengeId;
      let chObj = [...prev.challenge];
      let deletedObj = {
        ...prev.deleted,
        challenge: [...prev.deleted.challenge, chObj[i]],
      };
      chObj.splice(i, 1);
      let newObj = {
        ...prev,
        season: { ...prev.season, challengeId: chNo - 1 },
        challenge: [...chObj],
        deleted: deletedObj,
      };
      return newObj;
    });
  };

  // Format date for datetime-local input
  const formatDateTimeLocal = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  return (
    <div id={i} className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Challenge no. {i + 1}</h3>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => deleteChallenge(i)}
        >
          <Trash2 className="h-4 w-4 text-red-600" />
        </Button>
      </div>

      <div>
        <Label htmlFor={`challenge_name_${i}`}>Challenge Name</Label>
        <Input
          type="text"
          name="challenge_name"
          id={`challenge_name_${i}`}
          onChange={(e) => handleChange(i, e.target.name, e.target.value)}
          value={ch.challenge_name}
          placeholder="e.g., Walking, Running, Skipping"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor={`start_date_${i}`}>Start Date & Time</Label>
          <Input
            type="datetime-local"
            name="start_date"
            id={`start_date_${i}`}
            value={formatDateTimeLocal(ch.start_date)}
            onChange={(e) =>
              handleChange(i, "start_date", new Date(e.target.value))
            }
          />
        </div>
        <div>
          <Label htmlFor={`end_date_${i}`}>End Date & Time</Label>
          <Input
            type="datetime-local"
            name="end_date"
            id={`end_date_${i}`}
            value={formatDateTimeLocal(ch.end_date)}
            onChange={(e) =>
              handleChange(i, "end_date", new Date(e.target.value))
            }
          />
        </div>
      </div>
    </div>
  );
};

export const addChallenge = (setFormStates, user_id) => {
  setFormStates((prev) => {
    let chNo = prev.season.challengeId;
    let newObj = {
      ...prev,
      season: { ...prev.season, challengeId: chNo + 1 },
      challenge: [
        ...prev.challenge,
        { ...challengeObj(generateUUID(), user_id) },
      ],
    };
    return newObj;
  });
};

export const challengeObj = (uniqueId, user_id) => {
  return {
    challenge_id: "c" + String(uniqueId),
    challenge_name: "",
    description: "",
    start_date: "",
    end_date: "",
    user_id: user_id,
    task: [],
    event: [],
    group: [],
  };
};

export default ChallengeBlock;
